function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.3 18.8a2.202 2.202 0 01-.8-.1c-.3-.1-.4-.1-.5-.2l.3-1.1a2.92 2.92 0 00.9.2 1.132 1.132 0 001.2-.7 8.083 8.083 0 00.5-2.1l.4-3.9H9.8V9.8l1.2-.1h.5l.1-1a4.788 4.788 0 01.9-2.7 2.183 2.183 0 012.1-1 2.202 2.202 0 01.8.1c.3.1.5.1.6.2l-.3 1.1c-.1-.1-.3-.1-.4-.2a1.083 1.083 0 00-.6-.1 1.445 1.445 0 00-.7.2 1.205 1.205 0 00-.5.5c-.1.2-.2.5-.3.7a2.958 2.958 0 00-.2 1l-.1 1.1h2.3v1.1h-2.4l-.5 4.3q-.15.9-.3 1.5a4.328 4.328 0 01-.5 1.2 2.36 2.36 0 01-.9.8 2.768 2.768 0 01-1.3.3z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 1A11 11 0 111 12 10.968 10.968 0 0112 1m0-1a12 12 0 1012 12A12.035 12.035 0 0012 0z"
});

function SvgFn(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "fn.5b8b2.svg";
export { SvgFn as ReactComponent };